// Stealth Clock — standalone shift timeline PAGE (org-admin facing, read-only).
//
// Kept as a direct-URL fallback at /dashboard/shift-timeline, mirroring how
// EmployeeActivity works. The primary entry point is the "Shift Timeline" button on
// DashboardV2, which opens ShiftTimelineDrawer. Both render the same shared panel.
import React from 'react';
import { CalendarClock } from 'lucide-react';
import { useDashTheme } from '../../pages/DashboardV2/hooks/useDashTheme';
import { ShiftTimelinePanel } from './ShiftTimelinePanel';

export function ShiftTimeline() {
  const t = useDashTheme();

  return (
    <div style={{ padding: t.s[6], maxWidth: 1100, margin: '0 auto' }}>
      <div style={{ marginBottom: t.s[5] }}>
        <h1
          style={{
            margin: 0,
            fontSize: t.font.size.xl,
            fontWeight: t.font.weight.semibold,
            letterSpacing: '-0.01em',
            color: t.c.text,
            display: 'flex',
            alignItems: 'center',
            gap: t.s[2],
          }}
        >
          <CalendarClock size={20} /> Shift timeline
        </h1>
        <p style={{ margin: '4px 0 0', fontSize: t.font.size.base, color: t.c.textSecondary }}>
          When your team marked themselves on and off duty.
        </p>
      </div>
      <ShiftTimelinePanel active />
    </div>
  );
}

export default ShiftTimeline;
